import axios from 'axios'

const instance = axios.create({
  baseURL:
    'https://credenciamento-dot-porto-seguro-r-financeiros.uc.r.appspot.com',
})

export default instance
